<template>
   <label class="check-container"><span v-if="text != undefined" class="check-text">{{text}}</span>
      <input :class="{green: green}" type="checkbox" :checked="isChecked" :value="value" @input="$emit('input', $event.target)">
      <span :class="{green: green}" class="checkmark"></span>
   </label>
</template>

<script>
export default {
   props: ['value', 'text', 'isChecked', 'green']
}
</script>

<style lang="scss" scoped>
.check-container {
   display: block;
   position: relative;
   padding-left: 15px;
   margin-bottom: 7px;
   cursor: pointer;
   -webkit-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
   word-wrap: break-word;

   .check-text {
      margin-left: 10px;
      position: relative;
      display: inline-block;
   }

   &:hover >.checkmark{
      background-color: #2196f3;

      &.green {
         background-color: $bard-green;
      }
   }

   input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
      margin-right: 10px;
      margin-bottom: 10px;

      &:checked ~ .checkmark{
         background-color: #2196F3;

         &:after {
            display: block;
         }
      }

      &.green {
         &:checked ~ .checkmark{
            background-color: $bard-green;

            &:after {
               display: block;
            }
         }
      }
   }

   .checkmark {
      position: absolute;
      display: inline-block;
      top: 3px;
      left: 0;
      height: 16px;
      width: 16px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 3px;

      &:after {
         content: "";
         position: absolute;
         display: none;
      }

      &:after {
         left: 5px;
         top: 2px;
         width: 5px;
         height: 10px;
         border: solid white;
         border-width: 0 2px 2px 0;
         -webkit-transform: rotate(45deg);
         -ms-transform: rotate(45deg);
         transform: rotate(45deg);
      }
   }
}
</style>
